<template>
	<div>
		<AppHeader title="텐텐쿠폰 스탬프 현황 히스토리" is-history />

		<AppContent>
			<AsStampHistoryIndex />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';
import AsStampHistoryIndex from '@/components/AsStamp/AsStampHistoryIndex';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		AsStampHistoryIndex,
	},
};
</script>
